function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.663 6.337c.45.45.45 1.179 0 1.628L12.628 11l3.035 3.035a1.151 1.151 0 01-1.628 1.628L11 12.628l-3.035 3.035a1.151 1.151 0 11-1.628-1.628L9.372 11 6.337 7.965a1.151 1.151 0 011.628-1.628L11 9.372l3.035-3.035c.45-.45 1.178-.45 1.628 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgSmall = function SvgSmall(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22
    }, props), _ref)
  );
};

export default SvgSmall;